import React, { Fragment } from "react";
import { Route } from "react-router-dom";
import NavBar from "../components/Layout/NavBar/NavBar";
import LaunchBanner from "../components/LaunchBanner/LaunchBanner";
import ScrollToTop from "../utils/ScrollToTop";
import PopUpDialog from "../components/PopUpDialog/PopUpDialog";
import CookiesConsent from "../components/CookiesConsent/CookiesConsent";
import Footer from "../components/Layout/Footer/Footer";

export default function RouteWithOptionalNavElements({
  exact,
  path,
  component: Component,

  hasNavBar,
  hasFooter,
  hasPopUpDialog,
  hasCookiesConsent,
  hasLaunchBanner = true, // Default to true for backward compatibility

  ...rest
}) {
  return (
    <Route
      exact={exact}
      path={path}
      {...rest}
      render={(routeProps) => {
        return (
          <Fragment>
            {hasNavBar ? <NavBar /> : null}
            {hasNavBar && hasLaunchBanner ? <LaunchBanner /> : null}
            <div className="content">
              <ScrollToTop />
              <Component {...routeProps} />
            </div>
            {hasFooter ? <Footer /> : null}
            {/* {hasPopUpDialog ? <PopUpDialog /> : null} */}{" "}
            {/* Commented out for now */}
            {hasCookiesConsent ? <CookiesConsent /> : null}
          </Fragment>
        );
      }}
    />
  );
}
